// extracted by mini-css-extract-plugin
module.exports = {"header":"scenarioBody_header__2ez6u","container":"scenarioBody_container__XpQiq"};
    if(module.hot) {
      // 1783592055570
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  